document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.nk-cart form[action^="/cart"]');
  if (!form) return;

  function updateQty(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { window.location.reload(); });
  }

  form.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-nk-cart-dec]');
    var inc = e.target.closest('[data-nk-cart-inc]');
    var remove = e.target.closest('[data-nk-cart-remove]');
    if (!dec && !inc && !remove) return;
    e.preventDefault();

    var row = e.target.closest('[data-nk-cart-line]');
    var line = row.getAttribute('data-nk-cart-line');
    var input = row.querySelector('[data-nk-cart-qty]');
    var qty = parseInt(input.value, 10) || 1;

    if (remove) { updateQty(line, 0); return; }
    if (dec) qty = Math.max(0, qty - 1);
    if (inc) qty = qty + 1;
    input.value = qty;
    updateQty(line, qty);
  });

  form.addEventListener('change', function (e) {
    var input = e.target.closest('[data-nk-cart-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    updateQty(line, qty);
  });
});
